import ___default from "lodash";
import { includesIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
const getForayAppCustomParametersINI = (customForayParameters) => {
  return `
# Add custom parameter required by ForayApp
# Each line is a key value pair like ParameterName=ParameterValue
# Line starting with # is a comment line

${customForayParameters.map(
    (c) => `# ${c.isRequired ? "Required Parameter:" : "Optional Parameter:"}${c.displayName}
${c.displayName}=${c.value}

`
  ).join("")}
`;
};
const getCustomParametersFromINI = (existingForayAppParameters, parameterIni) => {
  let lines = parameterIni.split("\n");
  ___default.each(existingForayAppParameters, (e) => {
    e.value = "";
  });
  ___default.each(lines, (line) => {
    if (!!(line == null ? void 0 : line.trim()) && !line.startsWith("#") && line.includes("=")) {
      const indexOfFirstEqual = line.indexOf("=");
      const key = line.substring(0, indexOfFirstEqual);
      const value = line.substring(indexOfFirstEqual + 1);
      const itemToUpdate = existingForayAppParameters.find((e) => e.displayName === key);
      if (!!itemToUpdate) {
        itemToUpdate.value = value;
      }
    }
  });
  return existingForayAppParameters;
};
const getForayAppCustomParametersV2 = (templateSelected) => {
  var _a, _b;
  if (!templateSelected) {
    return [];
  }
  const customParameters = ((_b = (_a = templateSelected == null ? void 0 : templateSelected.forayAppParams) == null ? void 0 : _a.workflow) == null ? void 0 : _b.customParameters) || {};
  const forayAppParameters = ___default.map(customParameters, (p, i) => ({
    key: p["key"],
    isRequired: false,
    displayName: p["key"],
    value: p["value"]
  }));
  return forayAppParameters;
};
const getForayAppCustomParameters = (templateSelected) => {
  var _a, _b;
  if (!templateSelected) {
    return [];
  }
  return (_b = (_a = templateSelected == null ? void 0 : templateSelected.Properties) == null ? void 0 : _a.filter((p) => p.PropertyName.startsWith("ForayApp.Parameter.")).map((p) => parseForayAppProperty(p)).filter((c) => c.key !== "INVALID_KEY")) != null ? _b : [];
};
const parseForayAppProperty = (forayAppProperty) => {
  var _a, _b, _c;
  if (!((_a = forayAppProperty == null ? void 0 : forayAppProperty.PropertyName) == null ? void 0 : _a.startsWith("ForayApp.Parameter."))) {
    return {
      key: "INVALID_KEY",
      isRequired: false,
      displayName: "Invalid Key",
      value: ""
    };
  }
  return {
    key: forayAppProperty.PropertyName,
    isRequired: includesIgnoreCase(forayAppProperty.PropertyName, "ForayApp.Parameter.Optional.") ? false : true,
    displayName: forayAppProperty.PropertyName.replace("ForayApp.Parameter.Optional.", "").replace("ForayApp.Parameter.", ""),
    value: (_c = (_b = forayAppProperty.PropertyValue) == null ? void 0 : _b.trim()) != null ? _c : ""
  };
};
const getCustomForayParametersFromScopeField = (filterEntities) => {
  if (!filterEntities) {
    return [];
  }
  return filterEntities.filter((p) => p.Dimension.startsWith("ForayApp.Parameter.")).map((p) => parseForayAppPropertyFromFilter(p)).filter((c) => c.key !== "INVALID_KEY");
};
const parseForayAppPropertyFromFilter = (filterEntity) => {
  var _a, _b;
  if (!filterEntity.Dimension.startsWith("ForayApp.Parameter.")) {
    return {
      key: "INVALID_KEY",
      isRequired: false,
      displayName: "Invalid Key",
      value: ""
    };
  }
  return {
    key: filterEntity.Dimension,
    isRequired: includesIgnoreCase(filterEntity.Dimension, "ForayApp.Parameter.Optional.") ? false : true,
    displayName: filterEntity.Dimension.replace("ForayApp.Parameter.Optional.", "").replace("ForayApp.Parameter.", ""),
    value: !!(filterEntity == null ? void 0 : filterEntity.Values) && ((_b = (_a = filterEntity == null ? void 0 : filterEntity.Values) == null ? void 0 : _a.length) != null ? _b : 0) > 0 ? filterEntity.Values[0].trim() : ""
  };
};
export {
  getCustomForayParametersFromScopeField,
  getCustomParametersFromINI,
  getForayAppCustomParameters,
  getForayAppCustomParametersINI,
  getForayAppCustomParametersV2,
  parseForayAppProperty,
  parseForayAppPropertyFromFilter
};
//# sourceMappingURL=ForayAppSetting.utils.js.map
